import React, {useEffect, useState} from 'react';
import {StyleSheet, View, TouchableOpacity, Platform} from 'react-native';

import {observer} from 'mobx-react';
import {useNavigation} from '@react-navigation/native';

import {SVGIcon, RNEText} from '../../components';

import {colorPalette, colors} from '../../../core/config/color.config';

import {PractitionerProfile} from '../../server/types/practitioner-profile.types';
import {ConsultationStatusEnum} from '../../server/types/consultation.types';
import {ConsultationRequestResBody} from '../../server/types/consultation.types';

import ConsultationPhoto from '../consultation/ConsultationPhoto';

import {PopoverItemKey} from '../popover/data/popoverItems.data';
import {ProcedureStatusEnum} from '../../server/types/procedure.types';
import { width, height, totalSize } from 'react-native-dimension';
import { getFullNameLastNameFirst } from '../../utils/common.utils';

interface HeaderConsultationPatientProps {
  doctorData?: PractitionerProfile;
  serviceRequest?: ConsultationRequestResBody;
  onMenuItemClick?: (itemKey: PopoverItemKey) => void;
  onBackClickFromList?: () => void;
}

const HeaderConsultationPatient = (props: HeaderConsultationPatientProps) => {
  const navigation = useNavigation();

  const [displayName, setDisplayName] = useState('');
  const [location, setLocation] = useState('');

  const onBackClick = () => {
    if (navigation.canGoBack()) {
      navigation.goBack();
    }
  };

  useEffect(() => {
    if (props.serviceRequest?.subject) {
      switch (props.serviceRequest.status) {
        case ConsultationStatusEnum.PENDING:
          // setDisplayName(
          //   `Patient ${props.serviceRequest.subject.patientId
          //     .substring(0, 6)
          //     .toUpperCase()}`,
          // );
          setDisplayName(
            `${getFullNameLastNameFirst(props.serviceRequest?.subject?.humanName) || ''}`,
          );
          setLocation('');
          break;

        case ConsultationStatusEnum.CANCELLED:
          // setDisplayName(
          //   `Patient ${props.serviceRequest.subject.patientId
          //     .substring(0, 6)
          //     .toUpperCase()}`,
          // );
          setDisplayName(
            `${getFullNameLastNameFirst(props.serviceRequest?.subject?.humanName) || ''}`,
          );
          setLocation('');
          break;

        case ConsultationStatusEnum.DECLINED:
          // setDisplayName(
          //   `Patient ${props.serviceRequest.subject.patientId
          //     .substring(0, 6)
          //     .toUpperCase()}`,
          // );
          setDisplayName(
            `${getFullNameLastNameFirst(props.serviceRequest?.subject?.humanName) || ''}`,
          );
          setLocation('');
          break;

        case ConsultationStatusEnum.ONGOING:
          // setDisplayName(
          //   `${props.serviceRequest?.subject?.humanName.given[0]} ${props.serviceRequest?.subject?.humanName.family}`,
          // );
          setDisplayName(
            `${getFullNameLastNameFirst(props.serviceRequest?.subject?.humanName) || ''}`,
          );
          setLocation(props.serviceRequest?.subject.location || '--');
          break;

        case ConsultationStatusEnum.COMPLETED:
          // setDisplayName(
          //   `${props.serviceRequest?.subject?.humanName.given[0]} ${props.serviceRequest?.subject?.humanName.family}`,
          // );
          setDisplayName(
            `${getFullNameLastNameFirst(props.serviceRequest?.subject?.humanName) || ''}`,
          );
          setLocation(props.serviceRequest?.subject.location || '--');
          break;
        case ConsultationStatusEnum.ARCHIVED:
            // setDisplayName(
            //   `${props.serviceRequest?.subject?.humanName?.given[0] || 'N/A'} ${props.serviceRequest?.subject?.humanName?.family || ''}`,
            // );
            setDisplayName(
            `${getFullNameLastNameFirst(props.serviceRequest?.subject?.humanName) || ''}`,
            );
            setLocation(props.serviceRequest?.subject?.location || '--');
          break;

        default:
          break;
      }

      if (props.serviceRequest?.procedure) {
        if (
          props.serviceRequest?.status === ConsultationStatusEnum.PENDING &&
          props.serviceRequest?.procedure?.status === ProcedureStatusEnum.TO_PAY
        ) {
          setDisplayName(
            getFullNameLastNameFirst(
              props.serviceRequest.subject.humanName,
            ),
          );
          setLocation(props.serviceRequest?.subject.location || '--');
        }
      }
    }
  }, [
    props.serviceRequest?.status,
    props.serviceRequest?.subject,
    props.serviceRequest?.procedure,
  ]);

  return (
    <View accessibilityRole="button" style={styles.mainContainer}>
      <TouchableOpacity
        activeOpacity={0.75}
        onPress={
          props.onBackClickFromList ? props.onBackClickFromList : onBackClick
        }>
        <View style={styles.backContainer}>
          <SVGIcon name="left-gray" size={20} />
        </View>
      </TouchableOpacity>

      <View style={styles.profileContainer}>
        <View style={styles.profilePhoto}>
          <ConsultationPhoto
            photo={props.serviceRequest?.subject?.photo}
            size={totalSize(4.5)}
          />
        </View>

        <View style={styles.nameProfessionContainer}>
          <RNEText
            label={
              props.serviceRequest?.subject ? displayName : '-'
            }
            variant="button"
            // weight="bold"
            style={{fontSize: totalSize(1.5), fontFamily:'Quicksand-Bold'}}
            numberOfLines={2}
          />
          {!!location && (
            <RNEText
              label={location}
              variant="button"
              // weight="500"
              color={colors.gray.regular}
              numberOfLines={1}
              style={{fontFamily:'Quicksand-Regular', fontSize: totalSize(1.4)}}
            />
          )}
        </View>
      </View>
    </View>
  );
};

export default observer(HeaderConsultationPatient);

const styles = StyleSheet.create({
  mainContainer: {
    paddingHorizontal: width(4),
    flexDirection: 'row',
    alignItems: 'center',
    width: width(72),
  },
  backContainer: {
    marginRight: width(3),
    marginBottom: Platform.OS === 'ios' ? height(1) : height(0),
  },
  profileContainer: {
    flex: 1,
    flexDirection: 'row',
    alignItems: 'center',
  },
  profilePhoto: {
    // borderRadius: width(5),
    // borderWidth: width(0.2),
    borderColor: colorPalette.primary,
    width: width(8.5),
    height: width(8.5),
    paddingBottom: Platform.OS === 'ios' ? totalSize(1.2) : totalSize(0),
    alignItems: 'center',
    justifyContent: 'center',
  },
  imageStyle: {
    height: width(8.5),
    width: width(8.5),
    borderRadius: width(5),
    borderWidth: width(0.2),
    borderColor: colorPalette.primary,
  },
  nameProfessionContainer: {
    marginLeft: width(3.5),
    flex: 1,
    minWidth: 0,
  },
});
